export default __webpack_public_path__ + "static/media/instagram.b14870ee.svg";